import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckLargeCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "check_circle-24px_1_",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:none;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_5426",
			className: "st0",
			d: "M0,0h24v24H0V0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_5427",
			d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M10,17l-5-5l1.4-1.4l3.6,3.6l7.6-7.6L19,8 L10,17z"
		})
	]
});
export default SvgCheckLargeCircle;
